"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableHeader = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("../../../styles");
var SortableLabel_1 = require("../SortableLabel/SortableLabel");
var styles_2 = require("./styles");
function TableHeader(props) {
    var sortable = props.sortable, sortDirection = props.sortDirection, onSortChange = props.onSortChange, style = props.style, rest = __rest(props, ["sortable", "sortDirection", "onSortChange", "style"]);
    var _a = styles_1.useStyles(styles_2.createTableStyles), classes = _a.classes, css = _a.css;
    if (!sortable) {
        return react_1.default.createElement("th", __assign({ className: css(classes.th, style) }, rest));
    }
    return (react_1.default.createElement("th", __assign({ className: css(classes.th, style) }, rest),
        react_1.default.createElement(SortableLabel_1.SortableLabel, { direction: sortDirection, onChange: onSortChange }, props.children)));
}
exports.TableHeader = TableHeader;
TableHeader.defaultProps = {
    sortable: false,
    sortDirection: '',
    onSortChange: function () { return null; },
};
//# sourceMappingURL=TableHeader.js.map